import React from 'react';
import { mockNetworks } from '@/data/mockNetworks';
import { getNetworkColor } from './NetworkColorUtils';
import { NodeData } from './NetworkTypes';

interface NetworkLegendProps {
  networkGroups: Record<string, NodeData[]>;
  isDark: boolean;
}

export const NetworkLegend: React.FC<NetworkLegendProps> = ({ networkGroups, isDark }) => {
  return (
    <div className="flex flex-wrap gap-3 justify-center mt-4">
      {Object.entries(networkGroups).map(([networkType, networkNodes], index) => {
        const networkObject = mockNetworks.find((n) => n.type === networkType);
        const networkName = networkObject ? networkObject.name : networkType;
        const networkColor = getNetworkColor(networkType, index, isDark);
        
        return (
          <div key={`legend-${networkType}`} className="flex items-center gap-1.5">
            <div style={{ backgroundColor: networkColor }} className="w-3 h-3 rounded-full" />
            <span className="text-xs">
              {networkName || networkType}
            </span>
          </div>
        );
      })}
    </div>
  );
};
